import { useUser } from "@shared/hooks/user";
import { IButtonHandler } from "@shared/modules/sweepstakes/components/Modal/types";
import React from "react";

import { Button } from "./Button";
import classes from "./style.module.css";

const ButtonContainer = ({ handleBuyTime }: IButtonHandler) => {
  const { balanceWin: totalWin } = useUser() ?? {};
  const computedTotalWin = Math.floor(totalWin / 100);

  const hasDisabled = (value: number): boolean => {
    return computedTotalWin < value;
  };

  return (
    <div className={classes.buyInternetTimeButtons}>
      <Button
        value={1.0}
        handleClick={handleBuyTime}
        disabled={hasDisabled(1)}
      />
      <Button
        value={5.0}
        handleClick={handleBuyTime}
        disabled={hasDisabled(5)}
      />
      <Button
        handleClick={handleBuyTime}
        value={10.0}
        disabled={hasDisabled(10)}
      />
      <Button
        handleClick={handleBuyTime}
        value={20.0}
        disabled={hasDisabled(20)}
      />
      <Button
        handleClick={handleBuyTime}
        value={50.0}
        disabled={hasDisabled(50)}
      />
      <Button
        handleClick={handleBuyTime}
        value={100.0}
        disabled={hasDisabled(100)}
      />
    </div>
  );
};

export default ButtonContainer;
